var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddOffer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-add-offer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M27.945 9.708l-6.917-7.461c-0.21-0.226-0.503-0.354-0.812-0.354h-14.117c-1.29 0-2.338 1.049-2.338 2.338v23.538c0 1.29 1.049 2.338 2.338 2.338h19.803c1.29 0 2.338-1.050 2.338-2.338v-17.308c0-0.281-0.106-0.549-0.295-0.753zM21.052 5.532l3.435 3.706h-3.435v-3.706zM25.902 27.892h-19.803c-0.069 0-0.123-0.054-0.123-0.123v-23.537c0-0.068 0.055-0.123 0.123-0.123h12.738v6.239c0 0.612 0.496 1.108 1.108 1.108h6.079v16.315c0.001 0.068-0.053 0.122-0.122 0.122z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M20.654 16.277h-3.546v-3.546c0-0.612-0.496-1.108-1.108-1.108s-1.108 0.496-1.108 1.108v3.546h-3.546c-0.612 0-1.108 0.496-1.108 1.108s0.496 1.108 1.108 1.108h3.546v3.546c0 0.612 0.496 1.108 1.108 1.108s1.108-0.496 1.108-1.108v-3.546h3.546c0.612 0 1.108-0.496 1.108-1.108s-0.496-1.108-1.108-1.108z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddOffer);
export default __webpack_public_path__ + "static/media/icon-add-offer.c25fce45.svg";
export { ForwardRef as ReactComponent };